import Image from 'next/image';
import styles from './audience.module.scss';
import parse from 'html-react-parser';

interface Card {
  title: string;
  text: string;
  iconUrl: string;
}

interface TestingServicesProps {
  title: string;
  text?: string;
  buttonText?: string;
  buttonImage?: string;
  image?: string;
  cards: Card[];
  isDifferentColor?: boolean;
}

const Audience = ({ title, text, cards, isDifferentColor = true }: TestingServicesProps) => {
  return (
    <section className={isDifferentColor ? styles.container : styles.containerDifferent}>
      <div className={styles.section}>
        <div className={styles.section__head__wrapper}>
          <h2 className={styles.section__head__wrapper__title}>{title}</h2>
          <div className={styles.section__head__wrapper__description}>{text}</div>
        </div>
        <div className={styles.section__blocks}>
          {cards.map((card, index) => (
            <div key={index} className={styles.section__blocks__block}>
              {card.iconUrl && (
                <div className={styles.section__blocks__block__icon}>
                  <Image src={card.iconUrl} alt={card.title} width={36} height={36} objectFit="contain" />
                </div>
              )}
              <h3 className={styles.section__blocks__block__title}>{parse(card.title)}</h3>
              <p className={styles.section__blocks__block__subtitle}>{card.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Audience;
